import { Breakpoint } from '@gousto-internal/citrus-react'

const breakpoint = `${Number.parseInt(Breakpoint.Small, 10) - 1}px`

const isMobile = () => window.matchMedia(`(max-width: ${breakpoint})`).matches

export { isMobile }
